module.exports = __webpack_public_path__ + "img/best-analytics.2d750117.png";